<template>

  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="mb-4 col-lg-4 col-md-6 col-sm-12" v-for="brand in brands" :key="brand.id">

        <div class="card border-0  shadow rounded img-object-fit">
          <img :src="brand.image" :alt="brand.name" class="card-img-top">
          <div class="row">
            <div class="col">

              <router-link class="text-decoration-none" :to="{name:'SingleBrand', params:{slug:brand.slug}}">
                <h4 class="text-dark">{{ brand.name }}</h4>
              </router-link>
              <div v-if="brand.description != null" v-html="brand.description.slice(0,50)" class="text-muted "></div>
              <router-link :to="{name:'SingleBrand', params:{slug:brand.slug}}">
                <button class="btn btn-sm border-0 text-muted font-weight-bold">
                  <span class="pl-1"  v-t="`brand.card.more`"></span>
                  <m-icon icon="arrow-left"/>
                </button>
              </router-link>

            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="col-lg-12 text-center my-3">
      <m-paginate1 class="text-center" :meta="pagination" :on-change-page="changePage"/>
    </div>

  </div>

</template>

<script>
import {mapGetters} from "vuex";
import mIcon from "../../Icons/Icon";
import mPaginate1 from "../../Pagination/Paginate1";

export default {
  name: "Brands300",
  components: {mIcon, mPaginate1},
  computed: {
    ...mapGetters({
      brands: "Brand/getBrands",
      pagination: 'Brand/getPagination',
    }),
  },
  methods: {
    changePage(page) {
      this.$store.dispatch("Brand/getBrands", page);
      const currentRoute = this.$route
      this.$router.push({name: currentRoute.name, query: {...currentRoute.query, page: page}})
    },
  },
  async mounted() {
    await this.$store.dispatch("Brand/getBrands")
  }
}
</script>

<style scoped>
.card .card-img-top {
  border-radius: 15px 15px 0 0;
}

.card {
  height: 100% !important;
  cursor: pointer;
}

.img-object-fit {
  object-fit: cover;
}
</style>